// UserEmailOptOut defines which email types the user wants to opt-out from
export interface UserEmailOptOut {
  courseMailSequence: boolean;  // If true, user does NOT want course mail sequence emails
  recommendationMails: boolean; // If true, user does NOT want recommendation notification emails
  videoPublished: boolean;      // If true, user does NOT want video published notification emails
  eventReminder: boolean;       // If true, user does NOT want event reminder emails
}

export type UserEmailOptOutKey = keyof UserEmailOptOut;

export const ALL_EMAIL_OPT_OUT_KEYS: UserEmailOptOutKey[] = ['courseMailSequence', 'videoPublished', 'recommendationMails', 'eventReminder'];

export const EMAIL_OPT_OUT_LABELS: Record<UserEmailOptOutKey, string> = {
  courseMailSequence: 'Kurs E-Mail-Sequenz',
  videoPublished: 'Neue Videos',
  recommendationMails: 'Tradingideen',
  eventReminder: 'Event-Erinnerungen',
};
